/**
 * `/survey/t/:token` — trả lời khảo sát qua link email, không cần đăng nhập (người tốt nghiệp).
 * Link dùng 1 lần (TT 83 C9-c).
 */
import { useState } from "react";
import { Result, Spin, message } from "antd";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { getTokenForm, submitToken } from "@/features/surveys/api";
import { SurveyFormView } from "@/features/surveys/SurveyFormView";

type ApiErr = { response?: { data?: { detail?: string } } };

export function SurveyByToken() {
  const { token = "" } = useParams();
  const [done, setDone] = useState(false);
  const form = useQuery({
    queryKey: ["survey-token", token],
    queryFn: () => getTokenForm(token),
    retry: false,
    enabled: !done,
  });
  const mut = useMutation({
    mutationFn: (answers: Parameters<typeof submitToken>[1]) => submitToken(token, answers),
    onSuccess: () => setDone(true),
    onError: (err: ApiErr) => message.error(err.response?.data?.detail ?? "Không nộp được phiếu"),
  });
  if (done) return <Result status="success" title="Đã nộp phiếu — cảm ơn bạn!" />;
  if (form.isLoading) return <Spin style={{ display: "block", margin: "64px auto" }} />;
  if (!form.data)
    return (
      <Result status="warning" title="Link khảo sát không hợp lệ, đã dùng hoặc khảo sát đã đóng." />
    );
  return (
    <div style={{ maxWidth: 800, margin: "32px auto", padding: "0 16px" }}>
      <SurveyFormView form={form.data} submitting={mut.isPending} onSubmit={mut.mutate} />
    </div>
  );
}
